import { render, staticRenderFns } from "./AssetHistDetail.vue?vue&type=template&id=489ac267&scoped=true"
import script from "./AssetHistDetail.vue?vue&type=script&lang=js"
export * from "./AssetHistDetail.vue?vue&type=script&lang=js"
import style0 from "./AssetHistDetail.vue?vue&type=style&index=0&id=489ac267&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489ac267",
  null
  
)

export default component.exports